import { baseDroneApi } from "./redux";

export const DroneCoreMiddlewares = [
  baseDroneApi.middleware,
];

export const DroneCoreReducers = {
  [baseDroneApi.reducerPath]: baseDroneApi.reducer,
};